(function (global) {
  if (global.BionoboPdfLibrary && global.BionoboPdfLibrary.__controllerReady) {
    if (typeof document !== 'undefined') {
      document.querySelectorAll('[data-bn-pdf-library]').forEach(global.BionoboPdfLibrary.init);
    }
    if (typeof module === 'object' && module.exports) module.exports = global.BionoboPdfLibrary;
    return;
  }

  function normalizeLanguage(value) {
    var language = String(value || '').trim().toLocaleLowerCase();
    return language === 'es' || language === 'ar' || language === 'all' ? language : 'en';
  }

  function filterPdfs(items, language) {
    var selected = normalizeLanguage(language);
    if (selected === 'all') return items.slice();
    return items.filter(function (item) {
      return normalizeLanguage(item.language) === selected;
    });
  }

  function init(root) {
    if (!root || root.__bnPdfLibraryInitialized) return;

    function readCards() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-bn-pdf-card]')).map(function (element) {
      return { element: element, language: element.dataset.language || 'en' };
    });
    }
    var filters = Array.prototype.slice.call(root.querySelectorAll('[data-bn-pdf-filter]'));
    var empty = root.querySelector('[data-bn-pdf-empty]');
    var status = root.querySelector('[data-bn-pdf-status]');
    var selectedLanguage = normalizeLanguage(root.dataset.defaultLanguage || 'en');

    function updateFilters() {
      filters.forEach(function (button) {
        var active = normalizeLanguage(button.dataset.language) === selectedLanguage;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function render() {
      var cards = readCards();
      var visible = filterPdfs(cards, selectedLanguage);
      cards.forEach(function (card) {
        card.element.hidden = visible.indexOf(card) === -1;
      });
      if (empty) empty.hidden = visible.length !== 0;
      if (status) {
        status.textContent = visible.length === 1
          ? root.dataset.resultOne
          : root.dataset.resultPrefix + visible.length + root.dataset.resultSuffix;
      }
    }

    filters.forEach(function (button) {
      button.addEventListener('click', function () {
        selectedLanguage = normalizeLanguage(button.dataset.language);
        updateFilters();
        render();
      });
    });

    root.addEventListener('bn:guide-records-updated', function () {
      var requested = root.querySelector('[data-bn-guide-requested-download="true"]');
      if (requested) selectedLanguage = normalizeLanguage(requested.getAttribute('data-bn-guide-download'));
      updateFilters(); render();
    });

    root.__bnPdfLibraryInitialized = true;
    root.classList.toggle('is-filter-ready', true);
    updateFilters();
    render();
  }

  function handleSectionLoad(event) {
    var target = event && event.target;
    var root = target && target.matches && target.matches('[data-bn-pdf-library]')
      ? target
      : target && target.querySelector
        ? target.querySelector('[data-bn-pdf-library]')
        : null;
    if (root) init(root);
  }

  var api = {
    normalizeLanguage: normalizeLanguage,
    filterPdfs: filterPdfs,
    init: init,
    handleSectionLoad: handleSectionLoad,
    __controllerReady: true,
  };

  if (typeof module === 'object' && module.exports) module.exports = api;
  global.BionoboPdfLibrary = api;

  if (typeof document !== 'undefined') {
    function initializeAll() {
      document.querySelectorAll('[data-bn-pdf-library]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
    } else {
      initializeAll();
    }
    document.addEventListener('shopify:section:load', handleSectionLoad);
  }
})(typeof window === 'undefined' ? globalThis : window);
